module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-raised-button",
    class: _vm.buttonClass,
    style: (_vm.buttonStyle),
    attrs: {
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "rippleColor": _vm.rippleColor,
      "rippleOpacity": _vm.rippleOpacity,
      "disabled": _vm.disabled,
      "keyboardFocused": _vm.keyboardFocused,
      "wrapperClass": "mu-raised-button-wrapper",
      "centerRipple": false
    },
    on: {
      "KeyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit,
      "click": _vm.handleClick
    }
  }, [(_vm.label && _vm.labelPosition === 'before') ? _c('span', {
    staticClass: "mu-raised-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.label && _vm.labelPosition === 'after') ? _c('span', {
    staticClass: "mu-raised-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb177f3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/raisedButton/raisedButton.vue
// module id = 3686
// module chunks = 1